
var actual_JSON;

var chosenIndex;

export const setActualJson = (json) => {
	actual_JSON = json;
}

export function deleteInput(){
	console.log('deleteInput');
	document.getElementById("search").value = "";

			document.querySelector('.search-results').classList.remove('expand');
			document.querySelector('.service').classList.remove('expand');

			document.querySelector('.vermRightContent').classList.remove('show');
}

function createP(text){
	let result = document.createElement('p');
	result.appendChild(document.createTextNode(text));
	return result;
}

export function createChapter(header,content,index){
	let chapterDiv = document.createElement('div');
	chapterDiv.classList.add("vermService");
	let divider = document.createElement('div');
	divider.classList.add("rightdivider");
	if (index != 0){chapterDiv.appendChild(divider)};
	chapterDiv.appendChild(createP(header));
	content.forEach(elem => chapterDiv.appendChild(createP(elem)));
	return chapterDiv;
}


export function createLinkChapter(header,content,index){
	let chapterDiv = document.createElement('div');
	chapterDiv.classList.add("vermService");
	let divider = document.createElement('div');
	divider.classList.add("rightdivider");
	if (index != 0){chapterDiv.appendChild(divider)};
	chapterDiv.appendChild(createP(header));
	content.forEach(elem => chapterDiv.appendChild(createA(elem[0],elem[1])));
	return chapterDiv;
}

function createA(text, href){
	let result = document.createElement('a');
	result.setAttribute('href', href);
	result.setAttribute('target', '_blank');
	result.appendChild(document.createTextNode(text));
	return result;
}


function updateDOM(){
	//SIDEBAR
	document.getElementsByClassName("vermRightContent")[0].innerHTML = '<div class="vermHeading headRight">'+actual_JSON.Services[chosenIndex].name+'</div>';
	actual_JSON.Services[chosenIndex].sidebars[0].sidebar.forEach(function(elem,index) {
		if (elem.title == "Beispieldaten"){
			document.getElementsByClassName("vermRightContent")[0].appendChild(createLinkChapter(elem.title,elem.descriptions,index))
		} else {
			document.getElementsByClassName("vermRightContent")[0].appendChild(createChapter(elem.title,elem.descriptions,index))
		}
	}
	);
	document.querySelector('.vermRightContent').classList.add('show');
	document.querySelector('.vermNav').classList.remove('hide');
}

function showSearchResult(){
  document.querySelector('.search-results').classList.toggle('expand');
}

function updateSearchProposals(proposal,chooseService,filter){
	let services = proposal.map(x => [x.item.name].concat(x.item.synonyms)).flat().filter(t => t.toUpperCase().includes(filter.toUpperCase())).sort();
	console.log(services);
	if (filter.length > 0){
			document.querySelector('.search-results').classList.add('expand');
			document.querySelector('.service').classList.add('expand');

	} else {
			document.querySelector('.search-results').classList.remove('expand');
			document.querySelector('.service').classList.remove('expand');
	}
	document.getElementsByClassName("search-result")[0].textContent = '';
	services.forEach((x) =>
		document.getElementsByClassName("search-result")[0].appendChild(createLI(x, chooseService,undefined))//.appendChild(document.createTextNode(x)))
		);
}

export function search(fuse,chooseService) {
	document.querySelectorAll(".services li").forEach(x => x.classList.remove('selected'));
	var searchValue = document.getElementById("search").value;
	var search = fuse.search(searchValue);
	console.log(search);
	if (search.length > 0){
		chosenIndex = search[0].refIndex;
		chooseService(chosenIndex);
	}
	//updateDOM();
	updateSearchProposals(search,chooseService,searchValue);
}

export function hideServices(){
	console.log("change");
	document.querySelector('.services').classList.remove('expand');
	document.querySelector('.open').classList.remove('rotate');
}

/*SERVICES AUFLISTEN*/
export function showServices(){
	document.querySelector('.search-results').classList.remove('expand');
	document.querySelector('.service').classList.remove('expand');

	document.querySelector('.open').classList.toggle('rotate');
	document.querySelector('.services').classList.toggle('expand');
}


export function setSearchField(service,chooseService,index){
	document.getElementById("search").value = service;
	if (index != undefined){
		document.querySelectorAll(".services li").forEach(x => x.classList.remove('selected'));
		document.querySelector(".services li:nth-child("+(index+1)+")").classList.add('selected');
	}
	chosenIndex = actual_JSON.Services.findIndex((elem) => {return (elem.name == service || elem.synonyms.includes(service))});
	chooseService(chosenIndex);
	showSearchResult();
	document.querySelector('.service').classList.remove('expand');
	updateDOM();
	document.querySelector('.search-results').classList.remove('expand');
}

export function createLI(text,chooseService,index){
	console.log(index);
	let elem = document.createElement('li');
	elem.appendChild(document.createTextNode(text));
	elem.onclick = ()=>{setSearchField(text,chooseService,index)};
	return elem;
}